/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../../../legalentities/model/model';
import '../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "jp": {
                "nested": {
                  "common": {
                    "nested": {
                      "Name": {
                        "fields": {
                          "firstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "Address": {
                        "fields": {
                          "agrexCode": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "postalCode": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "prefectureIsoCode": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "kanjiPrefecture": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "kanjiCity": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "kanjiTown": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "katakanaPrefecture": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "katakanaCity": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "katakanaTown": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "buildingName": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "kanjiArea": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "katakanaArea": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "chomeBanchi": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "kanjiBuildingName": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "katakanaBuildingName": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          }
                        }
                      },
                      "CompanyType": {
                        "values": {
                          "BUSINESS": 1,
                          "PERSONAL": 2,
                          "JAPAN_COMPANY": 3
                        }
                      },
                      "JcbFlowStatus": {
                        "values": {
                          "NEW": 1,
                          "ON_HOLD": 2,
                          "PENDING": 3,
                          "RETURNED": 4,
                          "RETRYING": 5,
                          "APPROVED": 6,
                          "DECLINED": 7,
                          "CLOSED": 8
                        }
                      },
                      "JcbJudgement": {
                        "values": {
                          "DO_NOT_USE": 0,
                          "OK": 1,
                          "NG": 2,
                          "RETURN": 3
                        }
                      },
                      "Company": {
                        "fields": {
                          "kanjiCompanyName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "katakanaCompanyName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "romajiCompanyName": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "companyAddress": {
                            "type": "squareup.onboard.activation.jp.common.Address",
                            "id": 4,
                            "rule": "optional"
                          },
                          "companyType": {
                            "type": "squareup.onboard.activation.jp.common.CompanyType",
                            "id": 5,
                            "rule": "optional"
                          },
                          "corporateNumber": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "corporatePhoneNumber": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "administrativeAction": {
                            "type": "bool",
                            "id": 8,
                            "rule": "optional"
                          },
                          "administrativeActionExplanation": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "licenseNumber": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "licenseHolderName": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "licenseType": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "primaryGoods": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "website": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "informationAboutBusiness": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "documentFiles": {
                            "type": "squareup.legalentities.model.Business.DocumentFile",
                            "id": 16,
                            "rule": "repeated"
                          }
                        }
                      },
                      "Store": {
                        "fields": {
                          "kanjiName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "katakanaName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "romajiName": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "address": {
                            "type": "squareup.onboard.activation.jp.common.Address",
                            "id": 4,
                            "rule": "optional"
                          },
                          "url": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "phoneNumber": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "unitToken": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          }
                        }
                      },
                      "Persona": {
                        "fields": {
                          "kanjiName": {
                            "type": "squareup.onboard.activation.jp.common.Name",
                            "id": 1,
                            "rule": "optional"
                          },
                          "katakanaName": {
                            "type": "squareup.onboard.activation.jp.common.Name",
                            "id": 2,
                            "rule": "optional"
                          },
                          "romajiName": {
                            "type": "squareup.onboard.activation.jp.common.Name",
                            "id": 3,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": "squareup.onboard.activation.common.BirthDate",
                            "id": 4,
                            "rule": "optional"
                          },
                          "phoneNumber": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "gender": {
                            "type": "squareup.onboard.activation.common.Gender",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "BankAccountType": {
                        "values": {
                          "CHECKING": 1,
                          "SAVINGS": 2,
                          "INVESTMENT": 3,
                          "OTHER": 4
                        }
                      },
                      "BankAccount": {
                        "fields": {
                          "accountName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "accountNumber": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "accountType": {
                            "type": "squareup.onboard.activation.jp.common.BankAccountType",
                            "id": 3,
                            "rule": "optional"
                          },
                          "bankCode": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "branchCode": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          }
                        }
                      },
                      "ReaderAcquisitionType": {
                        "values": {
                          "READER_REQUEST": 1,
                          "STORE": 2,
                          "NONE": 3
                        }
                      },
                      "JcbField": {
                        "fields": {
                          "key": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "instruction": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "uploadRequired": {
                            "type": "bool",
                            "id": 3,
                            "rule": "optional"
                          },
                          "prefilledAnswer": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "optional": {
                            "type": "bool",
                            "id": 5,
                            "rule": "optional"
                          },
                          "options": {
                            "type": "string",
                            "id": 6,
                            "rule": "repeated"
                          }
                        }
                      },
                      "JcbAnswer": {
                        "fields": {
                          "key": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "answer": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "MetiRegistrationFormAnswer": {
                        "fields": {
                          "key": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "answer": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      },
                      "MerchantInformation": {
                        "fields": {
                          "merchantName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "merchantNameKana": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "violationFlag": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "businessForm": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "corporateNumber": {
                            "type": "string",
                            "id": 5,
                            "rule": "optional"
                          },
                          "contactLastName": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          },
                          "contactFirstName": {
                            "type": "string",
                            "id": 7,
                            "rule": "optional"
                          },
                          "contactLastNameKana": {
                            "type": "string",
                            "id": 8,
                            "rule": "optional"
                          },
                          "contactFirstNameKana": {
                            "type": "string",
                            "id": 9,
                            "rule": "optional"
                          },
                          "email": {
                            "type": "string",
                            "id": 10,
                            "rule": "optional"
                          },
                          "phone": {
                            "type": "string",
                            "id": 11,
                            "rule": "optional"
                          },
                          "postal": {
                            "type": "string",
                            "id": 12,
                            "rule": "optional"
                          },
                          "prefecture": {
                            "type": "string",
                            "id": 13,
                            "rule": "optional"
                          },
                          "city": {
                            "type": "string",
                            "id": 14,
                            "rule": "optional"
                          },
                          "town": {
                            "type": "string",
                            "id": 15,
                            "rule": "optional"
                          },
                          "street": {
                            "type": "string",
                            "id": 16,
                            "rule": "optional"
                          },
                          "cityKana": {
                            "type": "string",
                            "id": 17,
                            "rule": "optional"
                          },
                          "townKana": {
                            "type": "string",
                            "id": 18,
                            "rule": "optional"
                          },
                          "representativeLastName": {
                            "type": "string",
                            "id": 19,
                            "rule": "optional"
                          },
                          "representativeFirstName": {
                            "type": "string",
                            "id": 20,
                            "rule": "optional"
                          },
                          "representativeLastNameKana": {
                            "type": "string",
                            "id": 21,
                            "rule": "optional"
                          },
                          "representativeFirstNameKana": {
                            "type": "string",
                            "id": 22,
                            "rule": "optional"
                          },
                          "representativeBirthday": {
                            "type": "string",
                            "id": 23,
                            "rule": "optional"
                          },
                          "storeName": {
                            "type": "string",
                            "id": 24,
                            "rule": "optional"
                          },
                          "storeNameKana": {
                            "type": "string",
                            "id": 25,
                            "rule": "optional"
                          },
                          "mapPublicationDate": {
                            "type": "string",
                            "id": 26,
                            "rule": "optional"
                          },
                          "merchandiseCategory1": {
                            "type": "string",
                            "id": 27,
                            "rule": "optional"
                          },
                          "merchandiseCategory2": {
                            "type": "string",
                            "id": 28,
                            "rule": "optional"
                          },
                          "merchandiseDetail": {
                            "type": "string",
                            "id": 29,
                            "rule": "optional"
                          },
                          "storePhone": {
                            "type": "string",
                            "id": 30,
                            "rule": "optional"
                          },
                          "storePostal": {
                            "type": "string",
                            "id": 31,
                            "rule": "optional"
                          },
                          "storePrefecture": {
                            "type": "string",
                            "id": 32,
                            "rule": "optional"
                          },
                          "storeCity": {
                            "type": "string",
                            "id": 33,
                            "rule": "optional"
                          },
                          "storeTown": {
                            "type": "string",
                            "id": 34,
                            "rule": "optional"
                          },
                          "storeStreet": {
                            "type": "string",
                            "id": 35,
                            "rule": "optional"
                          },
                          "storeCityKana": {
                            "type": "string",
                            "id": 36,
                            "rule": "optional"
                          },
                          "storeTownKana": {
                            "type": "string",
                            "id": 37,
                            "rule": "optional"
                          },
                          "salesForm": {
                            "type": "string",
                            "id": 38,
                            "rule": "optional"
                          },
                          "contactDepartment": {
                            "type": "string",
                            "id": 39,
                            "rule": "optional"
                          },
                          "storeUrl": {
                            "type": "string",
                            "id": 40,
                            "rule": "optional"
                          },
                          "payType": {
                            "type": "string",
                            "id": 41,
                            "rule": "optional"
                          },
                          "building": {
                            "type": "string",
                            "id": 42,
                            "rule": "optional"
                          },
                          "buildingKana": {
                            "type": "string",
                            "id": 43,
                            "rule": "optional"
                          },
                          "storeBuilding": {
                            "type": "string",
                            "id": 44,
                            "rule": "optional"
                          },
                          "storeBuildingKana": {
                            "type": "string",
                            "id": 45,
                            "rule": "optional"
                          },
                          "businessCategory": {
                            "type": "string",
                            "id": 46,
                            "rule": "optional"
                          },
                          "businessSubCategory": {
                            "type": "string",
                            "id": 47,
                            "rule": "optional"
                          },
                          "storeNameRomaji": {
                            "type": "string",
                            "id": 48,
                            "rule": "optional"
                          },
                          "storePrefectureKana": {
                            "type": "string",
                            "id": 49,
                            "rule": "optional"
                          },
                          "prefectureKana": {
                            "type": "string",
                            "id": 50,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.Name && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.Address && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.CompanyType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.JcbFlowStatus && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.JcbJudgement && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.Company && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.Store && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.Persona && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.BankAccountType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.BankAccount && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.ReaderAcquisitionType && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.JcbField && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.JcbAnswer && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.MetiRegistrationFormAnswer && !$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.jp?.nested?.common?.nested?.MerchantInformation) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Name @ squareup/onboard/activation/jp/common.proto at 11:1
 */
export const Name = $root.lookupType('squareup.onboard.activation.jp.common.Name');
fixType(Name);
Builder.createAndAttachToType(Name);
/**
 * SOURCE Address @ squareup/onboard/activation/jp/common.proto at 16:1
 */
export const Address = $root.lookupType('squareup.onboard.activation.jp.common.Address');
fixType(Address, {
  agrexCode: {
    required: true
  },
  postalCode: {
    required: true
  },
  prefectureIsoCode: {
    required: true
  }
});
Builder.createAndAttachToType(Address);
/**
 * SOURCE CompanyType @ squareup/onboard/activation/jp/common.proto at 42:1
 */
export const CompanyType = $root.lookupEnum('squareup.onboard.activation.jp.common.CompanyType').values;
/**
 * SOURCE JcbFlowStatus @ squareup/onboard/activation/jp/common.proto at 48:1
 */
export const JcbFlowStatus = $root.lookupEnum('squareup.onboard.activation.jp.common.JcbFlowStatus').values;
/**
 * SOURCE JcbJudgement @ squareup/onboard/activation/jp/common.proto at 59:1
 */
export const JcbJudgement = $root.lookupEnum('squareup.onboard.activation.jp.common.JcbJudgement').values;
/**
 * SOURCE Company @ squareup/onboard/activation/jp/common.proto at 66:1
 */
export const Company = $root.lookupType('squareup.onboard.activation.jp.common.Company');
fixType(Company, {
  kanjiCompanyName: {
    required: true
  },
  katakanaCompanyName: {
    required: true
  },
  romajiCompanyName: {
    required: true
  },
  companyType: {
    required: true
  }
});
Builder.createAndAttachToType(Company);
/**
 * JCB activation is at store level.
 * One company can have multiple physical stores fronts, represented by multiple locations/units in the data model.
 *
 * SOURCE Store @ squareup/onboard/activation/jp/common.proto at 96:1
 */
export const Store = $root.lookupType('squareup.onboard.activation.jp.common.Store');
fixType(Store, {
  kanjiName: {
    required: true
  },
  katakanaName: {
    required: true
  },
  romajiName: {
    required: true
  },
  url: {
    required: true
  },
  phoneNumber: {
    required: true
  }
});
Builder.createAndAttachToType(Store);
/**
 * SOURCE Persona @ squareup/onboard/activation/jp/common.proto at 106:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.jp.common.Persona');
fixType(Persona, {
  kanjiName: {
    required: true
  },
  katakanaName: {
    required: true
  },
  romajiName: {
    required: true
  },
  birthDate: {
    required: true
  },
  phoneNumber: {
    required: true
  }
});
Builder.createAndAttachToType(Persona);
/**
 * SOURCE BankAccountType @ squareup/onboard/activation/jp/common.proto at 115:1
 */
export const BankAccountType = $root.lookupEnum('squareup.onboard.activation.jp.common.BankAccountType').values;
/**
 * SOURCE BankAccount @ squareup/onboard/activation/jp/common.proto at 122:1
 */
export const BankAccount = $root.lookupType('squareup.onboard.activation.jp.common.BankAccount');
fixType(BankAccount, {
  accountName: {
    required: true
  },
  accountNumber: {
    required: true
  },
  accountType: {
    required: true
  },
  bankCode: {
    required: true
  },
  branchCode: {
    required: true
  }
});
Builder.createAndAttachToType(BankAccount);
/**
 * Enum to figure out how the merchant is getting their reader
 *
 * SOURCE ReaderAcquisitionType @ squareup/onboard/activation/jp/common.proto at 141:1
 */
export const ReaderAcquisitionType = $root.lookupEnum('squareup.onboard.activation.jp.common.ReaderAcquisitionType').values;
/**
 * SOURCE JcbField @ squareup/onboard/activation/jp/common.proto at 147:1
 */
export const JcbField = $root.lookupType('squareup.onboard.activation.jp.common.JcbField');
fixType(JcbField);
Builder.createAndAttachToType(JcbField);
/**
 * SOURCE JcbAnswer @ squareup/onboard/activation/jp/common.proto at 162:1
 */
export const JcbAnswer = $root.lookupType('squareup.onboard.activation.jp.common.JcbAnswer');
fixType(JcbAnswer);
Builder.createAndAttachToType(JcbAnswer);
/**
 * SOURCE MetiRegistrationFormAnswer @ squareup/onboard/activation/jp/common.proto at 168:1
 */
export const MetiRegistrationFormAnswer = $root.lookupType('squareup.onboard.activation.jp.common.MetiRegistrationFormAnswer');
fixType(MetiRegistrationFormAnswer);
Builder.createAndAttachToType(MetiRegistrationFormAnswer);
/**
 * Field names match what's required by PayPay QR codes.  Order matches this CSV:
 * https://docs.google.com/spreadsheets/d/1W39aC8d_tsDlzDI4Pwy0FrPv_Sd9y7xy/edit#gid=1304534386
 *
 * SOURCE MerchantInformation @ squareup/onboard/activation/jp/common.proto at 186:1
 */
export const MerchantInformation = $root.lookupType('squareup.onboard.activation.jp.common.MerchantInformation');
fixType(MerchantInformation);
Builder.createAndAttachToType(MerchantInformation);